import { useState } from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

/**
 * Password TextField with a show/hide toggle. The toggle carries
 * aria-label/aria-pressed, and mouse-down is swallowed so clicking it does not
 * steal focus from the field being typed in.
 */
export default function PasswordField({ slotProps, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <TextField
      fullWidth
      {...props}
      type={show ? 'text' : 'password'}
      slotProps={{
        ...slotProps,
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                size="small"
                onClick={() => setShow((s) => !s)}
                onMouseDown={(e) => e.preventDefault()}
                aria-label={show ? 'Hide password' : 'Show password'}
                aria-pressed={show}
              >
                {show ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
              </IconButton>
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
